import { useMemo } from 'react';

import { httpClient, IHttpClientRequest } from '../client';

export const useMemoizedClient = (checkoutGatewayBaseUrlAddress: string, websiteHostAddress: string) =>
  useMemo(() => {
    const gatewayClient = httpClient(checkoutGatewayBaseUrlAddress);
    const parfumsClient = httpClient(websiteHostAddress);

    return {
      callHttpClient: <TResult>(params: IHttpClientRequest) => gatewayClient<TResult>(params),
      callParfumsHttpClient: <TResult>(params: IHttpClientRequest) => parfumsClient<TResult>(params),
    };
  }, [checkoutGatewayBaseUrlAddress, websiteHostAddress]);
